import { Button } from "antd";
import React, { useEffect, useState, useCallback } from "react";

const UnsplashSearch = ({ onImageSelect, initialQuery }) => {
  const [images, setImages] = useState([]);
  const [page, setPage] = useState(1);
  const [query, setQuery] = useState(initialQuery || "");
  const [selectedImage, setSelectedImage] = useState(null);

  const searchImages = useCallback(async () => {
    try {
      const response = await fetch(
        `https://api.unsplash.com/search/photos?query=${query}&per_page=10&page=${page}&order_by=latest`,
        {
          headers: {
            Authorization: `Client-ID ${process.env.REACT_APP_UNSPLASH_ACCESS_KEY}`,
          },
        }
      );

      const data = await response.json();
      setImages(data.results);
    } catch (error) {
      console.error("이미지 검색 중 오류 발생:", error);
    }
  }, [query, page]);

  const handleImageSelect = (image) => {
    setSelectedImage(image);
    onImageSelect(image.urls.regular);
  };

  useEffect(() => {
    if (query) {
      searchImages();
    }
  }, [page, query, searchImages]);

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setPage(1);
    searchImages();
  };

  const handleRefresh = () => {
    searchImages();
  };

  return (
    <div className="w-full mx-auto md:py-4 xl:px-[100px]">
      <form onSubmit={handleSearchSubmit} className="mb-6">
        <div className="flex gap-2 search-bar">
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="이미지 검색어를 입력하세요"
            className="flex-1 p-2 border rounded"
          />
          <button
            type="submit"
            className="px-4 py-2 bg-blue-500 text-white rounded"
          >
            검색
          </button>
          <button
            type="button"
            onClick={handleRefresh}
            className="px-4 py-2 bg-green-500 text-white rounded hide-mobile"
          >
            새로고침
          </button>
        </div>
      </form>

      {images?.length === 0 && (
        <div className="h-[150px] flex items-center justify-center">
          <p className="text-md md:text-lg text-gray-500">이미지를 찾을 수 없습니다.</p>
        </div>
      )}

      <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-5">
        {images?.map((image) => (
          <div
            key={image.id}
            onClick={() => handleImageSelect(image)}
            className="cursor-pointer hover:opacity-75 transition-opacity"
          >
            <img
              src={image.urls.thumb}
              alt={image.alt_description || "이미지"}
              className="w-full h-full md:w-[200px] md:h-[200px] object-cover rounded"
            />
          </div>
        ))}
      </div>

      <div className="pagination flex justify-between items-center mt-5">
        <Button
          onClick={() => setPage((prevPage) => Math.max(prevPage - 1, 1))}
          disabled={page === 1}
        >
          이전
        </Button>
        <Button onClick={() => setPage((prevPage) => prevPage + 1)}>
          다음
        </Button>
      </div>
    </div>
  );
};

export default UnsplashSearch;
